/**
 * NERO LIVING - Product Functions
 * Performance optimised image handling - ALL fabric images preloaded
 */

(function() {
  'use strict';

  // Preload image into cache
  window.neroPreloadImage = function(url) {
    if (!url || window.neroImageCache[url]) return;
    var img = new Image();
    img.src = url;
    window.neroImageCache[url] = img;
  };

  // Preload ALL fabric images at once
  window.neroPreloadAllFabrics = function() {
    if (!window.neroProductImages) return;
    window.neroProductImages.forEach(function(img) {
      if (img.alt && img.alt.toUpperCase().indexOf('#FABRIC') !== -1) {
        window.neroPreloadImage(img.url);
      }
    });
  };

  // Change main image with preload and fade
  window.neroChangeFabricImage = function(fabricName) {
    var mainImage = document.getElementById('nero-main-image');
    if (!mainImage || !fabricName) return;

    var searchName = fabricName.toUpperCase().trim().replace(/\s+/g, ' ');
    var match = null;

    for (var i = 0; i < window.neroProductImages.length; i++) {
      var img = window.neroProductImages[i];
      var alt = (img.alt || '').toUpperCase();

      if (alt.indexOf('#FABRIC SWATCH_' + searchName) !== -1 ||
          alt.indexOf('#FABRIC SWATCH_' + searchName.replace(/ /g, '_')) !== -1 ||
          alt.indexOf(searchName) !== -1) {
        match = img;
        break;
      }
    }

    if (match) {
      // If already cached, swap instantly
      if (window.neroImageCache[match.url]) {
        mainImage.src = match.url;
        return;
      }

      // Otherwise fade and load
      mainImage.style.transition = 'opacity 0.15s';
      mainImage.style.opacity = '0.6';

      var newImg = new Image();
      newImg.onload = function() {
        mainImage.src = match.url;
        mainImage.style.opacity = '1';
        window.neroImageCache[match.url] = newImg;
      };
      newImg.src = match.url;
    }
  };

  // Thumbnail click handler
  window.neroChangeImage = function(btn) {
    var url = btn.dataset.imageUrl;
    var mainImage = document.getElementById('nero-main-image');
    if (mainImage) mainImage.src = url;
    document.querySelectorAll('.nero-product__thumbnail').forEach(function(t) {
      t.classList.remove('is-active');
    });
    btn.classList.add('is-active');
  };

  // Preload ALL fabric images on page load (not just 5)
  window.addEventListener('load', function() {
    // Delay slightly to not block initial render
    setTimeout(function() {
      window.neroPreloadAllFabrics();
    }, 500);
  });

  // Also preload when user hovers over fabric dropdown button
  document.addEventListener('mouseenter', function(e) {
    if (e.target.closest && e.target.closest('.nero-swatch-dropdown__button')) {
      window.neroPreloadAllFabrics();
    }
  }, true);

})();
